import {
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from "@mui/material";
import React, { useState } from "react";

type Props = {
	open: boolean;
	attachmentName: string;
	onClose: (confirmed: boolean) => void;
	isDeleting?: boolean;
};

export const DeleteAttachmentConfirmationDialog = ({
	open,
	attachmentName,
	onClose,
	isDeleting = false,
}: Props) => {
	const [isClosing, setIsClosing] = useState(false);

	const handleCancel = () => {
		if (isClosing) return;
		onClose(false);
	};

	const handleConfirm = () => {
		if (isClosing) return;
		setIsClosing(true);
		onClose(true);
	};

	return (
		<Dialog
			open={open}
			onClose={handleCancel}
			aria-labelledby="delete-attachment-dialog-title"
			aria-describedby="delete-attachment-dialog-description"
		>
			<DialogTitle id="delete-attachment-dialog-title">
				{"Delete Attachment"}
			</DialogTitle>
			<DialogContent>
				<DialogContentText id="delete-attachment-dialog-description">
					Are you sure you want to delete <b>{attachmentName}</b>? This action
					cannot be undone.
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleCancel} color="inherit" disabled={isClosing}>
					Cancel
				</Button>
				<Button
					onClick={handleConfirm}
					color="secondary"
					variant="contained"
					disabled={isClosing}
					startIcon={isDeleting && <CircularProgress size="1rem" />}
				>
					Delete
				</Button>
			</DialogActions>
		</Dialog>
	);
};
